import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import * as $ from "jquery";

@Component({
  selector: "app-sample-center-result",
  templateUrl: "./sample-center-result.component.html",
  styleUrls: ["./sample-center-result.component.css"],
})
export class SampleCenterResultComponent implements OnInit {
  apiUrl: string;
  dtOptions: any = {};
  submitted = false;

  applicationId: string;
  collection_center_appId: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem('application_id');
		this.collection_center_appId = environment.APP_ID_COLLECTION_CENTER;
		this.sess.confirmUser(this.applicationId, this.collection_center_appId, 'Sample Collection Center');

    this.initTable();
  }

  initTable() {
    this.dtOptions = {
      paging: true,
      scrollX: true,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: true,
      processing: true,
      ordering: false,
      info: true,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }
}
